import React from "react";

const RightContactCardSection1 = (props) => {
  return (
    <div className="mt-10 flex justify-around rounded bg-gradient-to-r from-white to-gray-300 py-16 pt-12  ">
      <div className="mt-7">
        <img
          className="w-12"
          src={props.image}
          alt=""
        />
        {/* {props.image} */}
      </div>
      <div>
        <h1 className="font-sans text-2xl font-bold">{props.title}</h1>
        <ul className="mt-2 text-lg leading-loose">
          <li>{props.title1}</li>
          <li>{props.title2}</li>
        </ul>
      </div>
    </div> 
  );
};

export default RightContactCardSection1;
